import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=270a7485&scoped=true"
import script from "./Wizard.vue?vue&type=script&lang=js"
export * from "./Wizard.vue?vue&type=script&lang=js"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=270a7485&prod&scoped=true&lang=css"
import style1 from "./Wizard.vue?vue&type=style&index=1&id=270a7485&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270a7485",
  null
  
)

export default component.exports